import { render, staticRenderFns } from "./paperReport.vue?vue&type=template&id=34811818&scoped=true"
import script from "./paperReport.vue?vue&type=script&lang=js"
export * from "./paperReport.vue?vue&type=script&lang=js"
import style0 from "./paperReport.vue?vue&type=style&index=0&id=34811818&prod&lang=css"
import style1 from "./paperReport.vue?vue&type=style&index=1&id=34811818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34811818",
  null
  
)

export default component.exports